export interface IState {
	puff: IPuff
}

export interface IPuff {
	text: string,
	textColor: string,
	bgColor: string,
	bgColorIcone: string,
	hasLink: boolean,
	linkUrl: string,
	linkRel: string,
	linkAltText: string,
	icone: string,
	iconePil: string
};

const deafultState: IState = {
	puff: {
		text: 'text',
		textColor: 'textColor',
		bgColor: 'bg_color',
		bgColorIcone: 'bg_color_icone',
		hasLink: false,
		linkUrl: 'url',
		linkRel: 'rel',
		linkAltText: 'linkAltText',
		icone: 'icone',
		iconePil: 'icone_pil'
	}
};

export default deafultState;
